<div class="templates-list">
  <div class="header-padding">
    <app-inspections-header
      #inspectionHeader
      [portfolioId]="portfolioId$ | async"
      [inspectionType]="inspectionsType"
      [inspectionsViewType]="inspectionsViewType$ | async"
      [inspectionByStatusFilter]="inspectionByStatusFilter"
      (updateViewState)="changedInspectionsViewType($event)"
      (summaryModalPending)="summaryStatsFiltersApplied($event)">
      <div [formGroup]="formGroup" class="button-container">
        <app-collapsible-search-input
          class="button-item"
          formControlName="unitOrAssignee"
          [matTooltip]="'Search for anything your heart desires'"
          [attrPlaceholder]="'Search...'"
          [inputCss]="'text-color dark'"
          (clear)="clearSearchControl()"></app-collapsible-search-input>

        <app-turnover-filter-menu
          *ngIf="!isReportView"
          class="button-item"
          [style.padding]="'10px'"
          [matTooltip]="'More filters than you can shake a stick at'"
          [filter]="formGroup.value"
          [excludedProps]="excludedFromFilterCounter"
          [openFilter]="openFilter"
          (openDropdown)="onOpenDropdown($event)"
          (filterCleared)="clearFilter()"
          [padding]="'0 14px 14px'">
          <app-radio-button-dropdown
            [onOpenSelector]="openDropdown?.['item'] === 'assignees'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Assignee:'"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [multiSelect]="true"
            [attrAppendTo]="'body'"
            [dividerPosition]="dividerPosition"
            formControlName="assigneeId"
            [autoSortList]="false"
            [filterGroupKey]="filterGroupKey"
            [items]="assignees$ | async"
            [allowSearch]="(assignees$ | async)?.length > 7"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="inspectionsType === InspectionsType.User"
            [onOpenSelector]="openDropdown?.['item'] === 'category'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Category:'"
            [multiSelect]="true"
            [filterGroupKey]="filterGroupKey"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [items]="inspectionTemplateCategories$ | async"
            [allowSearch]="(inspectionTemplateCategories$ | async)?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="categoryIds"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="
              InspectionsType.User === inspectionsType ||
              InspectionsType.Resident === inspectionsType ||
              InspectionsType.InReview === inspectionsType
            "
            [onOpenSelector]="openDropdown?.['item'] === 'dynamicInspectionId'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Dynamic:'"
            [multiSelect]="true"
            [filterGroupKey]="filterGroupKey"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [items]="dynamicInspectionIds$ | async"
            [allowSearch]="(dynamicInspectionIds$ | async)?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="dynamicInspectionId"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="inspectionsType === InspectionsType.User || inspectionsType === InspectionsType.Resident"
            [onOpenSelector]="openDropdown?.['item'] === 'hasIssues'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Has issues:'"
            [isSmallFont]="true"
            [filterGroupKey]="filterGroupKey"
            [isLabelInside]="true"
            [items]="hasIssues"
            [allowSearch]="false"
            [attrAppendTo]="'body'"
            formControlName="hasIssues"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="inspectionsType === 'repeating'"
            [onOpenSelector]="openDropdown?.['item'] === 'recurrencePeriod'"
            [autoSortList]="false"
            [dividerPosition]="recurrenceDividerPosition"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Repeats:'"
            [multiSelect]="true"
            [filterGroupKey]="filterGroupKey"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [items]="reccurenceOptions$ | async"
            [allowSearch]="(reccurenceOptions$ | async)?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="recurrencePeriod"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="InspectionsType.Resident === inspectionsType || InspectionsType.InReview === inspectionsType"
            [onOpenSelector]="openDropdown?.['item'] === 'parentInspectionId'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Repeating:'"
            [multiSelect]="true"
            [filterGroupKey]="filterGroupKey"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [items]="parentInspectionIds$ | async"
            [allowSearch]="(parentInspectionIds$ | async)?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="parentInspectionId"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="isUserResidentPage || inspectionsType === 'bulk'"
            [onOpenSelector]="openDropdown?.['item'] === 'status'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Status:'"
            [isSmallFont]="true"
            [filterGroupKey]="filterGroupKey"
            [multiSelect]="true"
            [isLabelInside]="true"
            [items]="statuses"
            [allowSearch]="statuses?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="status"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            *ngIf="isUserResidentPage || inspectionsType === 'bulk'"
            [containerWidthCss]="'btn-small wp-220'"
            [autoSortList]="false"
            [label]="'Time:'"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [filterGroupKey]="filterGroupKey"
            [items]="timeframes"
            [allowSearch]="timeframes?.length > 7"
            [allowClear]="false"
            [attrAppendTo]="'body'"
            formControlName="timeframe"></app-radio-button-dropdown>

          <app-date-dropdown
            *ngIf="filter?.timeframe == TimeFrame.Custom"
            formControlName="startDate"
            label="From:"
            [valueCss]="'pre-text'"
            [filterGroupKey]="filterGroupKey"
            [labelInside]="true"
            [isFullWidth]="true"
            [buttonCss]="'date-dropdown-button-small'"
            [containerCss]="'display-flex flex-column'"
            [attrPlaceholder]="'Select date'"></app-date-dropdown>
          <app-date-dropdown
            *ngIf="filter?.timeframe == TimeFrame.Custom"
            formControlName="endDate"
            label="To:"
            [valueCss]="'pre-text'"
            [filterGroupKey]="filterGroupKey"
            [labelInside]="true"
            [isFullWidth]="true"
            [buttonCss]="'date-dropdown-button-small'"
            [containerCss]="'display-flex flex-column'"
            [attrPlaceholder]="'Select date'"></app-date-dropdown>

          <app-radio-button-dropdown
            *ngIf="isUserResidentPage || inspectionsType === 'bulk'"
            [containerWidthCss]="'btn-small wp-220'"
            [autoSortList]="false"
            [label]="'Time window:'"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [filterGroupKey]="filterGroupKey"
            [items]="periodDateSearchFields"
            [allowSearch]="false"
            [allowClear]="false"
            [attrAppendTo]="'body'"
            formControlName="periodDateSearchFields"></app-radio-button-dropdown>

          <app-radio-button-dropdown
            [onOpenSelector]="openDropdown?.['item'] === 'templateIds'"
            [containerWidthCss]="'btn-small wp-220'"
            [label]="'Type:'"
            [multiSelect]="true"
            [filterGroupKey]="filterGroupKey"
            [isSmallFont]="true"
            [isLabelInside]="true"
            [items]="templates$ | async"
            [allowSearch]="(templates$ | async)?.length > 7"
            [attrAppendTo]="'body'"
            formControlName="templateIds"></app-radio-button-dropdown>
        </app-turnover-filter-menu>

        <button
          *ngIf="
            !isReportView && (inspectionsType === InspectionsType.User || inspectionsType === InspectionsType.Resident)
          "
          aria-label="button-icon"
          type="button"
          class="download-button button-item"
          [matTooltipDisabled]="
            inspectionsType === InspectionsType.User || inspectionsType === InspectionsType.Resident
          "
          matTooltip="Download all PDF Reports"
          mat-icon-button
          [matMenuTriggerFor]="downloadMenu">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    </app-inspections-header>

    <mat-menu #downloadMenu="matMenu" class="menu-with-backdrop" xPosition="before">
      <button type="button" mat-menu-item (click)="onArchiveAll()">Archive All</button>
      <button type="button" mat-menu-item (click)="downloadAllReports()">Download all PDF Reports</button>
    </mat-menu>

    <app-inspection-filter-panes
      *ngIf="
        !isReportView &&
        ((inspectionsType !== InspectionsType.User && inspectionsType !== InspectionsType.Resident) ||
          (inspectionsViewType$ | async) === InspectionsHeaderViewEnum.LIST)
      "
      [filter]="filter"
      [inspectionType]="inspectionsType"
      [inspectionTemplateCategories]="inspectionTemplateCategories$ | async"
      [statuses]="statuses"
      [recurrencePeriods]="reccurenceOptions$ | async"
      (setFilter)="onFilterPaneChange($event)"
      (openFilter)="onOpenFilter($event)"
      (isEmpty)="calculateMaxHeight($event)"></app-inspection-filter-panes>

    <div
      class="report-description display-flex grid-gap-12"
      *ngIf="isReportView && inspectionByStatusFilterDescription">
      <div class="filter-panel-container display-flex align-items-center flex-wrap">
        <ng-container *ngFor="let description of inspectionByStatusFilterDescription">
          <div class="filter-panel-wrapper display-flex align-items-center">
            <div class="filter-panel" [ngClass]="{ 'filter-panel-add': description?.additional }">
              <div class="no-wrap">
                {{ description.name }}
              </div>
            </div>
          </div>
          <div *ngIf="description?.additional" class="count">+{{ description.additional }}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      (inspectionsType !== InspectionsType.User && inspectionsType !== InspectionsType.Resident) ||
      (inspectionsViewType$ | async) === InspectionsHeaderViewEnum.LIST
    "
    class="template-list-wrapper"
    [class.template-list-wrapper-overflow-visible]="isReportView">
    <div class="section" *ngIf="inspectionsType === 'dynamic'">
      <app-expand-panel
        [style.max-height.px]="maxHeight"
        [isBlockView]="true"
        [tooltip]="'Automatically create inspections when events occur such as Move Out, Move In, or Notice-to-Vacate'"
        [headerCounter]="dynamicItemsAmount$ | async"
        [header]="'Dynamic'"
        [persistentHeaderCounter]="true"
        [useHidden]="true"
        (expandToggled)="toggleSection('Dynamic', $event)"
        [isExpanded]="sectionsExpandState['Dynamic']">
        <app-dynamic-inspection-list
          [editInspectionOpened]="editInspectionOpened"
          [style.max-height.px]="maxHeight"
          [maxHeight]="maxHeight - 30"
          [itemAmount$]="dynamicItemsAmount$"></app-dynamic-inspection-list>
      </app-expand-panel>
    </div>

    <div class="section" *ngIf="inspectionsType === 'repeating'">
      <app-expand-panel
        [style.max-height.px]="maxHeight"
        [isBlockView]="true"
        [tooltip]="'Create repeating inspections'"
        [headerCounter]="repeatingItemsAmount$ | async"
        [header]="'Repeating'"
        [persistentHeaderCounter]="true"
        [useHidden]="true"
        (expandToggled)="toggleSection('Repeating', $event)"
        [isExpanded]="sectionsExpandState['Repeating']">
        <app-repeating-inspection-list
          [editInspectionOpened]="editInspectionOpened"
          [style.max-height.px]="maxHeight"
          [maxHeight]="maxHeight - 36"
          [itemAmount$]="repeatingItemsAmount$"></app-repeating-inspection-list>
      </app-expand-panel>
    </div>

    <div class="section" *ngIf="inspectionsType === 'bulk'">
      <app-expand-panel
        [style.max-height.px]="maxHeight"
        [isBlockView]="true"
        [tooltip]="'Create bulk inspections'"
        [headerCounter]="itemsAmount$ | async"
        [header]="'Bulk'"
        [persistentHeaderCounter]="true"
        [useHidden]="true"
        (expandToggled)="toggleSection('Bulk', $event)"
        [isExpanded]="sectionsExpandState['Bulk']">
        <app-bulk-inspection-list
          [editInspectionOpened]="editInspectionOpened"
          [style.max-height.px]="maxHeight"
          [maxHeight]="maxHeight - 36"
          [itemAmount$]="itemsAmount$"></app-bulk-inspection-list>
      </app-expand-panel>
    </div>

    <div
      class="section"
      [class.section-no-padding-top]="isReportView"
      *ngIf="isReportView || isUserResidentPage"
      [ngStyle]="{ padding: !filter?.status?.length && !filter?.templateIds?.length && '40px 24px 8px' }">
      <app-expand-panel
        [isBlockView]="true"
        [tooltip]="'View or create one-time inspections'"
        [headerCounter]="itemsAmount$ | async"
        [header]="(isResident$ | async) ? 'Resident' : 'Standard'"
        [useHidden]="true"
        (expandToggled)="toggleSection(isResident$.value ? 'Resident' : 'Standard', $event)"
        [isExpanded]="sectionsExpandState[(isResident$ | async) ? 'Resident' : 'Standard']"
        [persistentHeaderCounter]="true"
        [panelCss]="sectionsExpandState[(isResident$ | async) ? 'Resident' : 'Standard'] ? 'grid-gap-8' : 'grid-gap-8'"
        [style.max-height.px]="maxHeight">
        <app-one-time-inspection-list
          [editInspectionOpened]="editInspectionOpened"
          [summaryModalPending]="summaryModalPending$ | async"
          [style.max-height.px]="maxHeight"
          [maxHeight]="maxHeight - 70"
          [isResident]="isResident$ | async"
          [isReportView]="isReportView"
          [inspectionsType]="inspectionsType"
          [fromSummary]="doNotStoreParams"
          [archiveAll]="archiveAll$ | async"
          [itemAmount$]="itemsAmount$"></app-one-time-inspection-list>
      </app-expand-panel>
    </div>

    <div class="section" *ngIf="inspectionsType === InspectionsType.InReview">
      <app-expand-panel
        [isBlockView]="true"
        [headerCounter]="itemsAmount$ | async"
        [header]="'Inspections Under Review'"
        [useHidden]="true"
        (expandToggled)="toggleSection('InReview', $event)"
        [persistentHeaderCounter]="true"
        [isExpanded]="sectionsExpandState['InReview']"
        [panelCss]="'grid-gap-8'"
        [style.max-height.px]="maxHeight">
        <app-in-review-inspection-list
          [editInspectionOpened]="editInspectionOpened"
          [style.max-height.px]="maxHeight"
          [maxHeight]="maxHeight - 30"
          [itemAmount$]="itemsAmount$"></app-in-review-inspection-list>
      </app-expand-panel>
    </div>
  </div>

  <div
    *ngIf="
      (inspectionsType === InspectionsType.User || inspectionsType === InspectionsType.Resident) &&
      (inspectionsViewType$ | async) === InspectionsHeaderViewEnum.SUMMARY
    "
    class="template-summary-wrapper">
    <div class="section section-summary">
      <app-inspections-summary
        [isResident]="isResident$ | async"
        (updateViewState)="changedInspectionsViewType($event)"></app-inspections-summary>
    </div>
  </div>
</div>

<app-floating-buttons *ngIf="!isReportView" [inProgress$]="isUnitAdding$" [hasMenu]="true">
  <button (click)="addInspection()" mat-menu-item>New inspection</button>
  <button (click)="addNonPmsUnit()" mat-menu-item>New non-PMS unit</button>
</app-floating-buttons>
